import React from "react";
import Button from "../../atoms/button/button";
import './propositosStart.scss'
import { Link } from "react-router-dom";

function PropositosStart() {
	return (
		<div className="propositos-start">
			<div className="mentoria-propositos-header">
				<h2>Cumplir tus propósitos es posible</h2>
				<h3>Conoce la historia de Santiago Flores y cómo logró cumplir su propósito.</h3>
				<div className="mentoria-propositos-header__video-container">
					<div style={{ padding: "56.25% 0 0 0", position: "relative" }}>
						<iframe
							src="https://player.vimeo.com/video/718854601?badge=0&amp;autopause=0&amp;quality_selector=1&amp;progress_bar=1&amp;player_id=0&amp;app_id=58479"
							style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }}
							frameBorder="0"
							allow="autoplay; fullscreen; picture-in-picture"
							allowFullScreen></iframe>
							<script src="https://player.vimeo.com/api/player.js"></script>
					</div>
				</div>
			</div>
			<div className="mentoria-propositos-container">
				<div className="mentoria-propositos-container__center">
					<div className="mentoria-propositos-container__text">
						<h3 className="mentoria-propositos-container__text__title">Ahora comencemos a trabajar por tus sueños</h3>
						<h3 className="mentoria-propositos-container__text__subtitle">¡Cuéntanos qué quieres alcanzar!</h3>
					</div>
					<Link to="/propositos/seleccionar" className="mentoria-propositos-container__button">
						<Button
							type="button"
							text={"Selecciona tu propósito"}
							gtmClass="secondary"
						/>
					</Link>
				</div>
			</div>
		</div>
	);
}

export default PropositosStart;